// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__AhXkg","flex":"Footer_flex__oPmIV","gotoTopBtn":"Footer_gotoTopBtn__unrbn","contactNum":"Footer_contactNum__TOF6h"};